
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({ components: {} })
export default class LoadingPopup extends Vue {
  @Prop() private wholePagePopupMessage!: string;
  @Prop({ default: true }) isWholePage!: boolean;
  get containerClass() {
    return this.isWholePage ? 'zawa-popup' : 'zawa-popup-inline';
  }
}
